import { getZoneColor } from '@trainme/api/client';
import { cn } from '@/utils/uiUtils';

import { FiLoader, FiRefreshCw } from 'react-icons/fi';

type Props = {
  loading?: boolean;
  size?: number;
  className?: string;
  variant?: 'default' | 'strava';
};

export default function Loading({
  loading = true,
  size = 24,
  className = '',
  variant = 'default',
}: Props) {
  const color = getZoneColor(2);

  if (!loading) return null;
  return (
    <div
      className={cn([
        'h-full flex justify-center items-center gap-4 loading',
        className,
      ])}
    >
      {variant === 'default' && (
        <FiLoader
          className={`loading-icon text-${color}-700 flex-none`}
          style={{ width: size, height: size }}
        />
      )}
      {variant === 'strava' && (
        <FiRefreshCw
          className='loading-icon text-orange-500 flex-none'
          style={{ width: size, height: size }}
        />
      )}
    </div>
  );
}
